import { useQuery } from "@apollo/client/react"; import React, { useState, useEffect, useMemo } from "react";

import { Grid } from '@mui/material';
import { FileInput } from '../../../../components/fileInput/FileInput';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { MultipleFileInput } from "./components/MultipleFileInput";

export const StepCuidadosPaliativos = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI,
  idDatosGeneralesRI
}) => {
  const [cuidadosPaliativos, setCuidadosPaliativos] = useState(fullFormDataRI?.cuidadosPaliativos1 ?? {});
  const [combosRI, setCombosRI] = useState();
  const [childrenAction, setChildrenAction] = useState(null);

  const handleSubmit = () => {
    updateFormData('cuidadosPaliativos1', cuidadosPaliativos, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setCuidadosPaliativos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  const onDeleteImage = (name) => {
    handleChange(name, null);
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);


  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {

        if (!combosRI && !!input.comboName)
          return input;

        if (!!input.comboName)
          input.options = combosRI[input.name];

        switch (input.name) {
          case 'directivasAdjunto':
            return {
              ...input,
              //disabled: !cuidadosPaliativos?.directivasAnticipadas,
              required: cuidadosPaliativos?.directivasAnticipadas,
              onDeleteImage: () => onDeleteImage(input.name)
            };
          case 'idComboRIValorECOG':
            return {
              ...input,
              required: fullFormDataRI?.datosGenerales2?.enfermedadOncologica
            };
          case 'idComboRIValorTabaquismo':
            return {
              ...input,
              options: input.options.map((e) => { return { label: e.displayName, value: e.id }; })
            };
          case 'descSustancia':
            return {
              ...input,
              required: cuidadosPaliativos?.antecedenteConsumoSustancias
            };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [
    selectedPrograms,
    cuidadosPaliativos.directivasAnticipadas,
    cuidadosPaliativos.antecedenteConsumoSustancias,
    fullFormDataRI?.datosGenerales2?.enfermedadOncologica,
    combosRI]
  );


  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [cuidadosPaliativos, setDataSubmissionCallback, validatedinputsGroups]);


  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          {
            group.groupName === 'Estudios complementarios' ?

              <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                {group.groupName} {Boolean(childrenAction) && childrenAction}
              </label> :

              <label className='step-form-section-title'>{group.groupName}</label>
          }
          <Grid
            container>
            {group.inputs.map((input) => {
              return (
                input.name !== 'idComboRIValorECOG' && input.name !== 'estudioAdjunto' ?

                  <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                    handleDelete={() => onDeleteImage(input.name)}
                    input={input}
                    row
                    value={cuidadosPaliativos[input.name]} /> :


                  input.name === 'idComboRIValorECOG' && fullFormDataRI.datosGenerales2?.enfermedadOncologica ?

                    <RenderInputByTypeMobile
                      key={`${group.groupName}-${input.name}`}
                      grided
                      handleChange={input.type === 'file' ? handleChangeImage : handleChange}
                      handleDelete={() => onDeleteImage(input.name)}
                      input={input}
                      row
                      value={cuidadosPaliativos[input.name]} /> :


                    input.name === 'estudioAdjunto' ?

                      <MultipleFileInput
                        key={`${group.groupName}-${input.name}`}
                        handleChange={handleChange}
                        setChildrenAction={setChildrenAction}
                        prevEstudiosAdjuntos={cuidadosPaliativos[input.name]}
                        onDeleteImage={() => onDeleteImage(input.name)}
                        idDatosGeneralesRI={idDatosGeneralesRI} /> :

                      null);

            })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepCuidadosPaliativos;

const inputsGroups = [
  {
    groupName: '',
    inputs: [
      {
        displayName: '¿Posee directivas anticipadas?',
        name: 'directivasAnticipadas',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Subir directivas',
        name: 'directivasAdjunto',
        type: 'file',
        required: false,
        validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
        maxFileSize: 8
      },
      {
        displayName: 'Creencia o religión',
        name: 'religion',
        type: 'string',
        required: true
      },
      {
        displayName: 'Pasatiempos',
        name: 'pasatiempo',
        type: 'string',
        required: true
      },
      {
        displayName: 'Profesión/ocupación',
        name: 'profesionOcupacion',
        type: 'string',
        required: true
      },
      {
        displayName: 'Cuidador Principal?',
        name: 'cuidadorPrincipal',
        type: 'string',
        required: true
      },
      {
        displayName: 'Medico de Cabecera',
        name: 'medicoCabecera',
        type: 'string',
        required: true
      },
      {
        displayName: 'ECOG',
        comboName: 'ECOG',
        name: 'idComboRIValorECOG',
        type: 'select',
        required: true
      },
      {
        displayName: 'Otros estudios',
        name: 'otrosEstudios',
        type: 'string',
        required: false
      }]

  },
  {
    groupName: 'Estudios complementarios',
    inputs: [
      {
        displayName: 'Estudio complementario',
        name: 'estudioAdjunto'
      }]

  },
  {
    groupName: 'Hábitos',
    inputs: [
      {
        displayName: 'Tabaquismo',
        comboName: 'Tabaquismo',
        name: 'idComboRIValorTabaquismo',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: 'Antecedentes de alcoholismo',
        name: 'antecedenteAlcoholismo',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Antecedentes de consumo de sustancias',
        name: 'antecedenteConsumoSustancias',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Tipo de sustancia',
        name: 'descSustancia',
        type: 'string',
        required: false
      }]

  }];